/**
 * Created by 胡长伟 on 2019-04-18.
 */
import { Utils } from '../../app.base'

const CRON_FIELD_NAME = {
    Year: "Year", // 空，或 1970-2099 （* , - /）
    // 注意与 Day 互斥
    WkDay: "WkDay", // [1-7] 周日,周一...周六 （* , - / ? L #） 这里的L代表最后一周不能用 #，#代表第n周（制定了具体周 ，则只能指定具体周天）
    //
    Month: "Month", // 1-12 一月,...十二月 （* , - /）
    // 注意与 WeekDay 互斥
    Day: "Day", // 1-31 （* ? , - / L W）
    //
    Hour: "Hour", // 0-23 （* , - /）
    Minute: "Minute", // 0-599 （* , - /）
    Second: "Second" // 0-59 （* , - /）
};

const CRON_FIELD_TYPE = {
    All: "All", // 任意 { * } => always()
    Spec: "Spec", // 单值 { value } => on(value)
    Every: "Every", // 每 / { value/freq } => every(on(value), freq)
    Span: "Span", // 范围 - { v1 - v2 } //between(v1, v2)
    List: "List" // 值项 , { v1, v2, ... } => and(on(v1)).and(on(v2))... 暂不支持
};

export const TIME_LIMIT_TYPE = {
    NONE: 0, // 无限制
    TIMES: 1, // 限定次数
    TIMED: 2// 限定时间点
};

const chsNames = {};
chsNames[CRON_FIELD_NAME.Year] = "年";
chsNames[CRON_FIELD_NAME.WkDay] = "周天";
chsNames[CRON_FIELD_NAME.Month] = "月";
chsNames[CRON_FIELD_NAME.Day] = "日";
chsNames[CRON_FIELD_NAME.Hour] = "时";
chsNames[CRON_FIELD_NAME.Minute] = "分";
chsNames[CRON_FIELD_NAME.Second] = "秒";

/** json版cron域信息 */

// 周次取值及其中文含义
let VALID_WSEQ_VALS = [0, 1, 2, 3, 4, -1];
let VALID_WSEQ_MAP = {
    '0': '每周',
    '1': '第1周',
    '2': '第2周',
    '3': '第3周',
    '4': '第4周',
    '-1': '最后1周'
};
//所有有效的周次第选项
let VALID_WSEQ_ITEMS = [];
{
    for(let i = 0, c = VALID_WSEQ_VALS.length; i < c; i++) {
        let value = VALID_WSEQ_VALS[i];
        let text = VALID_WSEQ_MAP[value + ''];
        VALID_WSEQ_ITEMS[i] = {
            value: value,
            text: text
        }
    }
}

/** 判断是否为有效周次 */
function isValidWseq(wseq) {
    if(wseq == null) {// 没有当不指定周（==0）
        return true;
    }
    return VALID_WSEQ_VALS.indexOf(wseq) != -1;
}

/** 判断给定的域类型 是否在指定的类型之中 */
function isInFieldTypes(fieldType/* , fieldTypes ...*/) {
    let fieldTypes = Array.prototype.slice.call(arguments, 1);
    for(let i = 0, l = fieldTypes.length; i < l; i++) {
        if(fieldTypes[i] == fieldType) {
            return true;
        }
    }
    return false;
}

/** 判断对于给定的域名称，给定的频度是否有效（不能超过区间范围的一半） */
function isValidFreqFor(fieldName, freq) {
    freq = Utils.ParseInt(freq);
    //
    let NAME = CRON_FIELD_NAME;
    switch(fieldName) {
        case NAME.Year: // 频度限制在每10年之内
            return freq != null && freq >= 1 && freq <= 10;
        case NAME.WkDay: //
            return freq != null && freq >= 1 && freq <= 3;
        case NAME.Month:
            return freq != null && freq >= 1 && freq <= 6;
        case NAME.Day:
            return freq != null && freq >= 1 && freq <= 15;
        case NAME.Hour:
            return freq != null && freq >= 1 && freq <= 12;
        case NAME.Minute:
            return freq != null && freq >= 1 && freq <= 30;
        case NAME.Second:
            return freq != null && freq >= 1 && freq <= 30;
        default:
            return false;
    }
}

function isValidValueFor(fieldName, value) {
    value = Utils.ParseInt(value);
    //
    let NAME = CRON_FIELD_NAME;
    switch(fieldName) {
        case NAME.Year:
            return value != null && value >= 1970 && value <= 2099;
        case NAME.WkDay: // 周日-周六
            return value != null && value >= 1 && value <= 7;
        case NAME.Month:
            return value != null && value >= 1 && value <= 12;
        case NAME.Day:
            return value != null && value >= 1 && value <= 31;
        case NAME.Hour:
            return value != null && value >= 0 && value <= 23;
        case NAME.Minute:
            return value != null && value >= 0 && value <= 59;
        case NAME.Second:
            return value != null && value >= 0 && value <= 59;
        default:
            return false;
    }
}

const weekDayChsNames = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

// 1- 7 日 => 六
function toWeekDayName(wkDay) {
    let wkDayIndex = wkDay - 1; // 错1
    return weekDayChsNames[wkDayIndex];
}

function joinWkDayNames(wkDays, sepChars) {
    let wkDayNameItems = [];
    for(var i = 0, c = wkDays.length; i < c; i++) {
        wkDayNameItems[i] = toWeekDayName(wkDays[i]);
    }
    return wkDayNameItems.join(sepChars || ',');
}

export function CronField(name, type) {
    this.name = name || null;
    this.type = type || CRON_FIELD_TYPE.Spec;
    this.value = null; //int
    // 频度 */5
    this.freq = null; // int
    // 周次 1#2（-1代表最后一周）[0, 1, 2, 3, 4, -1]
    this.wseq = null; // int
    // 注意：指定某个周时，周天只能使用固定值
    this.values = null; // [int,...]
    //
    this.fromJson = function (json) {
        json = json || {};
        //
        if(Utils.isString(json)) {
            json = JSON.decode(json);
        }
        //
        this.name = json.name || this.name;
        this.type = json.type || this.type;
        //
        if(json.value != null) {
            this.value = json.value;
        }
        if(json.freq != null) {
            this.freq = json.freq;
        }
        if(json.wseq != null) {
            this.wseq = json.wseq;
        }
        if(json.values != null) {
            this.values = json.values;
        }
        //
        return this;
    };
    this.toJson = function () {
        let retInfo = {
            name: this.name,
            type: this.type
        };
        //
        if(this.value != null) {
            retInfo.value = this.value;
        }
        if(this.freq != null) {
            retInfo.freq = this.freq;
        }
        if(this.wseq != null) {
            retInfo.wseq = this.wseq;
        }
        if(this.values != null) {
            retInfo.values = Utils.merge(this.values);
        }
        //
        return retInfo;
    };
    //
    let NAME = CRON_FIELD_NAME;
    let TYPE = CRON_FIELD_TYPE;
    //
    let __lastErrMsg = null;
    this.getLastErrMsg = function () {
        return __lastErrMsg;
    };
    //
    this._isValidValue = function () {
        let tmpVal = null;
        if(TYPE.Spec == this.type) {// 单个值
            if(NAME.Day == this.name && this.value != null && this.value == -1) {// 最后一天特殊处理
                return true;
            }
            //
            if(!isValidValueFor(this.name, this.value)) {
                return false;
            }
        } else if(TYPE.Every == this.type) {// 每
            if(!isValidFreqFor(this.name, this.freq)) {
                return false;
            }
            //
            if(this.value == null) {// 无起始值
                return true;
            }
            // 有则要检查
            if(!isValidValueFor(this.name, this.value)) {
                return false;
            }
        } else if(TYPE.Span == this.type) {// 范围值
            if(!Utils.isArray(this.values) || this.values.length != 2) {
                return false;
            }
            for(let i = 0; i < this.values.length; i++) {
                tmpVal = this.values[i];
                if(tmpVal == null) {
                    return false;
                }
                if(!isValidValueFor(this.name, tmpVal)) {
                    return false;
                }
            }
        } else if(TYPE.List == this.type) {// 列表值
            if(this.values == null || this.values.length < 2) {
                return false;
            }
            for(let i = 0; i < this.values.length; i++) {
                tmpVal = this.values[i];
                if(tmpVal == null) {
                    return false;
                }
                if(!isValidValueFor(this.name, tmpVal)) {
                    return false;
                }
            }
        }

        return true;
    };
    //
    this.validate = function () {
        if(NAME.Year == this.name) {// 注意：前端暂时不支持List
            if(!isInFieldTypes(this.type, TYPE.All, TYPE.Spec, TYPE.Span)) {// 不能支持Every
                return false;
            }
        }
        else if(NAME.WkDay == this.name) {// 注意：前端暂时不支持List
            if(!isValidWseq(this.wseq)) {// 次第值域
                return false;
            }
            if(this.wseq != null) {// 指定了某个周，则必须使用固定周天
                if(this.wseq == 0) {
                    if(!isInFieldTypes(this.type, TYPE.All, TYPE.Spec, TYPE.Span)) {// 不能支持Every
                        return false;
                    }
                } else {
                    if(TYPE.Spec != this.type) {
                        return false;
                    }
                }
            }
        }
        else if(!isInFieldTypes(this.type, TYPE.All, TYPE.Spec, TYPE.Span, TYPE.Every)) {
            // 注意：前端暂时不支持List
            return false;
        }
        //
        return this._isValidValue();
    };
    //
    this.getDesc = function () {
        if(!this.validate()) {
            return "<无效" + chsNames[this.name] + ">";
        }

        let wseqX = null;
        let wseqDesc = "";
        let forWkDay = false;
        if(NAME.WkDay == this.name) {// 周天的处理
            forWkDay = true;
            //
            wseqX = this.wseq;
            if(wseqX == null) {
                wseqX = 0;
            }
            wseqDesc = VALID_WSEQ_MAP[wseqX + ''] + " ";
        }

        // {0}：域名, {1}：单位，{2}：的，{3}：次第
        let chsDesc = wseqDesc;
        if(TYPE.Spec == this.type) {// 单个值
            if(NAME.WkDay == this.name) {// 周天的处理
                chsDesc += "{2}" + toWeekDayName(this.value);
            } else if(NAME.Day == this.name && this.value != null && this.value == -1) {// 最后一天特殊处理
                chsDesc = "{2}最后一{0}";
            } else {
                chsDesc = "{3}" + this.value + "{1}";
            }
        } else if(TYPE.Every == this.type) {// 每（WkDay不会支持）
            if(this.value != null) {
                chsDesc += "{2}" + this.value + "{0}起每" + this.freq + "{1}";
            } else {
                chsDesc += "每" + this.freq + "{1}";
            }
        } else if(TYPE.Span == this.type) {// 范围值
            if(forWkDay) {
                chsDesc += "{2}" + toWeekDayName(this.values[0]) + " ~ " + toWeekDayName(this.values[1]);
            } else {
                chsDesc += "{2}" + this.values[0] + " ~ " + this.values[1] + "{0}";
            }
        } else if(TYPE.List == this.type) {// 范围值
            if(forWkDay) {
                chsDesc += "{2} " + joinWkDayNames(this.values, "、");
            } else {
                chsDesc += "{2} " + this.values.join("、") + " {0}";
            }
        } else {// always
            chsDesc += "每{0}";
        }
        //
        switch(this.name) {
            case NAME.Year:
                chsDesc = chsDesc.format("年", "年", "", "");
                break;
            case NAME.WkDay:
                chsDesc = chsDesc.format("周天", "个周天", "的", "第");
                break;
            case NAME.Month:
                chsDesc = chsDesc.format("月", "个月", "的", "第");
                break;
            case NAME.Day:
                chsDesc = chsDesc.format("日", "天", "的", "第");
                break;
            case NAME.Hour:
                chsDesc = chsDesc.format("时", "个小时", "的", "第");
                break;
            case NAME.Minute:
                chsDesc = chsDesc.format("分", "分钟", "的", "第");
                break;
            case NAME.Second:
                chsDesc = chsDesc.format("秒", "秒钟", "的", "第");
                break;
        }
        //
        return chsDesc;
    };
}

//
CronField.NAME = CRON_FIELD_NAME;
CronField.TYPE = CRON_FIELD_TYPE;
CronField.WSEQ_ITEMS = VALID_WSEQ_ITEMS;

/** json版cron表达式处理类 */
export function JsonCron() {
    // => CronField
    this.Year = null;
    this.WkDay = null;
    this.Month = null;
    this.Day = null;
    this.Hour = null;
    this.Minute = null;
    this.Second = null;

    let NAME = CRON_FIELD_NAME;
    let TYPE = CRON_FIELD_TYPE;

    /* 从json恢复信息 */
    this.fromJson = function (json) {
        json = json || {};
        //
        if(Utils.isString(json)) {
            json = JSON.decode(json);
        }
        //
        this.Year = new CronField(NAME.Year).fromJson(json.Year);
        this.WkDay = json.WkDay == null ? null : new CronField(NAME.WkDay).fromJson(json.WkDay);
        this.Month = new CronField(NAME.Month).fromJson(json.Month);
        this.Day = json.Day == null ? null : new CronField(NAME.Day).fromJson(json.Day);
        this.Hour = new CronField(NAME.Hour).fromJson(json.Hour);
        this.Minute = new CronField(NAME.Minute).fromJson(json.Minute);
        //
        this.Second = json.Second == null ? null : new CronField(NAME.Second).fromJson(json.Second);
        //
        return this;
    };
    /* 输出json对象 */
    this.toJson = function () {
        return {
            Year: this.Year == null ? null : this.Year.toJson(),
            WkDay: this.WkDay == null ? null : this.WkDay.toJson(),
            Month: this.Month == null ? null : this.Month.toJson(),
            Day: this.Day == null ? null : this.Day.toJson(),
            Hour: this.Hour == null ? null : this.Hour.toJson(),
            Minute: this.Minute == null ? null : this.Minute.toJson(),
            Second: this.Second == null ? null : this.Second.toJson()
        };
    };

    //
    let _singleFixedTime = false;
    /** 返回表达式对的是否为单个固定的时间点 */
    this.isSingleFixedTime = function () {
        return _singleFixedTime;
    };

    /* 验证表达式是否合法 */
    this.validate = function () {
        let singleFixedTime = true;
        //
        let field = null;
        // Year
        field = this.Year;
        if(field == null) {
            singleFixedTime = false;
        } else {
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        // Month
        field = this.Month;
        if(field == null) {
            singleFixedTime = false;
        } else {
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        // 是否使用周天
        let useWkDay = false;
        // WkDay
        field = this.WkDay;
        if(field != null) {
            useWkDay = true;
            //
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        // Day
        if(!useWkDay) {
            field = this.Day;
            if(field == null) {
                singleFixedTime = false;
            } else {
                if(!field.validate()) {
                    return false;
                }
                singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
            }
        }
        // Hour
        field = this.Hour;
        if(field == null) {
            singleFixedTime = false;
        } else {
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        // Minute
        field = this.Minute;
        if(field == null) {// 缺失则
            singleFixedTime = singleFixedTime && true; // 固定为0分
        } else {
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        // Second
        field = this.Second;
        if(field == null) {// 缺失则
            singleFixedTime = singleFixedTime && true; // 固定为0秒
        } else {
            if(!field.validate()) {
                return false;
            }
            singleFixedTime = singleFixedTime && field.type == TYPE.Spec;
        }
        //
        _singleFixedTime = singleFixedTime;
        //
        return true;
    };

    /* 返回中文描述 */
    this.getDesc = function () {
        let field = null;
        let desc = "";
        //
        field = this.Year;
        if(field == null) {
            desc += "每年";
        }
        else {
            desc += field.getDesc();
        }
        //
        field = this.Month;
        if(field == null) {
            desc += " 每月";
        }
        else {
            desc += " " + field.getDesc();
        }
        // 是否使用周天
        let useWkDay = false;
        field = this.WkDay;
        if(field != null) {
            useWkDay = true;
            desc += " " + field.getDesc();
        }
        //
        if(!useWkDay) {
            field = this.Day;
            if(field == null) {
                desc += " 每日";
            }
            else {
                desc += " " + field.getDesc();
            }
        }
        //
        field = this.Hour;
        if(field == null) {
            desc += " 每时";
        }
        else {
            desc += " " + field.getDesc();
        }
        //
        field = this.Minute;
        if(field == null) {
            desc += " 0分";
        }
        else {
            desc += " " + field.getDesc();
        }
        //
        field = this.Second;
        if(field == null) {
            desc += "";
        }
        else {
            desc += " " + field.getDesc();
        }
        //
        return desc;
    };

}

//
export default {
    CronField,
    JsonCron,
    TIME_LIMIT_TYPE
};




//////////////////
// WEBPACK FOOTER
// ./src/compo/cron/json-cron.js
// module id = 292
// module chunks = 1